var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ h5: this.$store.state.webType === 'h5' },attrs:{"id":"classroom"}},[_c('el-row',{staticClass:"page",attrs:{"span":24}},[_c('div',{staticClass:"banner-view"},[_c('div',{staticClass:"verify"},[_c('verify',{attrs:{"infos":_vm.infos},on:{"isOkShow":_vm.okOk}})],1)])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }